import isEmpty from "../utils/helpers";
import {signupToServiceReducer} from "../reducers/signupToServiceReducer";


export const selectLinkedAccounts = state => state.linkedAccounts.accounts;
export const selectLinkedAccountsLoading = state => state.linkedAccounts.loading;
export const selectLinkedAccountsError = state => state.linkedAccounts.error;
export const selectLanguage = (state) => state.language || {};
export const selectAuth = (state) => state.auth || {};
export const selectAccountInfo = (state) => state.accountInfo || {};
export const selectGuestOrder = (state) => state.guestOrder || {};
export const selectHomeInfo = (state) => state.homeInfo || {};
export const selectSignUp = (state) => state.signUp || {};
export const getUser = (state) => state.user || {};
export const getPayment = (state) => state.payment || {};
export const getSignupToService = (state) => state.signupToService || {};
export const getBilling = (state) => state.billing || {};
export const getPaymentProviders = (state) => state.paymentProviders || {}
export const selectIsActive = state => state.linkedAccounts.isActive;
export const selectLinkedUsers = state => state.linkedAccounts.linkedUsers;
export const getAccountAutoPayStatus = (state) => state.accountAutopay || {};
export const getLoadingState = (state) => state.loading.isLoading;
export const selectSuffixOptions = (state) => state.guestOrder.suffixOptions || [];

export const selectErrorMessage = (actions) => (state) => {
	const errors = actions.map((action) => state.errors[action]);

	if (isEmpty(errors)) {
		return '';
	}

	return errors.find((error) => !isEmpty(error));
};

export const getUserPermission = (state, moduleName, permissionName) => {
	const findPermission = state.auth.userPermission.find((x) => x.name === moduleName)
		? state.auth.userPermission.find((x) => x.name === moduleName).permissions.includes(permissionName)
		: false;

	return findPermission;
};

export const createLoadingSelector = (actions) => (state) => actions.some((action) => state.loading[action]);
